import { useTranslation } from "react-i18next";
import type { BienRow } from "@/schemas/bien";
import type { PortalPublicationRow } from "@/lib/portalPublish";
import { portalErrorText } from "@/lib/portalPublish";
import { UNIFIED_LEVEL, unifiedPublicationStatus, type UnifiedLevel } from "@/lib/publicationStatus";
import { cn } from "@/lib/utils";

const DOT: Record<UnifiedLevel, string> = {
  muted: "bg-text-muted/30",
  pending: "bg-warning animate-pulse",
  success: "bg-success",
  danger: "bg-danger",
  warning: "bg-warning",
};
const LABEL: Record<UnifiedLevel, string> = {
  muted: "text-text-muted",
  pending: "text-warning",
  success: "text-success",
  danger: "text-danger",
  warning: "text-warning",
};

/** Colonne « Statut » unique des workspaces Publication (cf. lib/publicationStatus). */
export function UnifiedStatusCell({ bien, row }: { bien: BienRow; row: PortalPublicationRow | null | undefined }) {
  const { t } = useTranslation();
  const status = unifiedPublicationStatus(bien, row);
  const level = UNIFIED_LEVEL[status];
  const tooltip =
    status === "refuse" ? portalErrorText(row) : status === "a_depublier" ? t("portals.stillOnlineHint") : "";
  return (
    <span title={tooltip || undefined} className="inline-flex items-center gap-1.5 whitespace-nowrap">
      <span className={cn("w-2.5 h-2.5 rounded-full inline-block shrink-0", DOT[level])} />
      <span className={cn("text-xs font-medium", LABEL[level])}>{t(`v2.publicationWs.unified.${status}`)}</span>
    </span>
  );
}

/** Pastille « OK » (Prêt photos). Aligné V1. */
export function OkBadge({ ok }: { ok: boolean }) {
  const { t } = useTranslation();
  if (!ok) return <span className="text-text-muted">—</span>;
  return (
    <span className="inline-flex items-center gap-0.5 text-[10px] font-semibold px-1.5 py-0.5 rounded bg-success/10 text-success">
      {t("v2.publicationWs.ok")}
    </span>
  );
}
